/**
 * @param time12h - time in 12-hour format (e.g., '02:30 PM') 
 * @returns time in 24-hour format (e.g., '14:30')
 */
export function convertTime12to24(time12h: string): string {
  const [time, modifier] = time12h.split(' ');

  let [hours, minutes] = time.split(':');

  if (hours === '12') {
    hours = '00';
  }

  if (modifier === 'PM') {
    hours = (parseInt(hours, 10) + 12).toString();
  }

  if (hours.length < 2) {
    hours = '0' + hours;
  }
  if (minutes.length < 2) {
    minutes = '0' + minutes;
  }

  return `${hours}:${minutes}`;
}

export function calculateDaysDifferenceFromNow(timestamp: string): number {
  const now = new Date().getTime();
  const date = new Date(timestamp).getTime();
  const minutesLeft = date - now;
  const diffDays = Math.round(minutesLeft / (1000 * 3600 * 24));
  return diffDays;
}

export function formatDateMMDDYYYY(timestamp: string): string {
  const date = new Date(timestamp);
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const year = (date.getFullYear() % 100).toString().padStart(2, '0');

  return `${month}/${day}/${year}`;
}

export function formatDateDayMonthYear(date: string) {
  const newDate = new Date(date);
  if (isNaN(newDate.getTime())) {
    throw new Error('Invalid date string');
  };

  const dateFormatOptions: Intl.DateTimeFormatOptions = { day: 'numeric', month: 'short',  year: 'numeric'};
  const formattedDate = new Intl.DateTimeFormat('en-US', dateFormatOptions).format(newDate);
  return formattedDate;
}

export function startsInFuture(timestamp: string): boolean {
  const today = new Date().getTime();
  const date = new Date(timestamp).getTime();
  return date > today;
}

/**
 * @param timeString - 'HH:MM' or 'HH:MM AM/PM'
 * @returns Date object with the specified time
 */
export function parseTimeToDate(timeString: string): Date {
  const trimmedTimeString = timeString.trim();
  const preparedTimeString = /(?:AM|PM)$/i.test(trimmedTimeString)
    ? convertTime12to24(trimmedTimeString.toUpperCase())
    : trimmedTimeString;

  const [hours, minutes] = preparedTimeString.split(":");
  const date = new Date();
  date.setHours(parseInt(hours), parseInt(minutes), 0, 0);
  return date;
}

export function getAYearFromNow() {
    const d = new Date();
    d.setFullYear(d.getFullYear() + 1);
    return d
}

const MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

export function human_time_ago(zulu: string | number | Date): string {
  const t = new Date(zulu);
  const d = Date.now() - t.getTime();
  if (d < 60000) return " just now";
  if (d < 120000) return " a minute ago";
  if (d < 3600000) return " " + Math.floor(d/60000) + " minutes ago";
  if (d < 7200000) return " an hour ago";
  if (d < 86400000) return " " + Math.floor(d/3600000) + " hours ago";
  return " on " + (t.getMonth()+1) + "/" + t.getDate();
}

/** Formats a zulu time string as `[<Month> <day>, <h:mm am/pm>, <is in the past>]` in the browser tz. */
export function my_format(d: string | number | Date): [string, string, boolean] {
  const dd = new Date(d); // zulu time string as a Date relevant to browser tz
  const dp = dd < new Date();
  let ampm = "am";
  let hours: number | string = dd.getHours();
  if (hours >= 12) {
      ampm = "pm";
      hours = hours == 12 ? hours : hours-12;
  } else if (hours == 0) {
      hours = "12";
  }
  const dt = hours + ":" + (dd.getMinutes()<10?"0":"") + dd.getMinutes() + ampm;
  return [MONTHS[dd.getMonth()] + ' ' + dd.getDate(), dt, dp];
}
